export const formatTextToParagraphs = (text: string): React.ReactNode[] => {
  if (!text) return [];
  return text.split('\n').map((paragraph, index) => (
    <p key={index} className="typography-h3 text-secondary mb-4">
      {paragraph}
    </p>
  ));
};
